import { Component, Input } from '@angular/core';
import { magicPreviewDummyData } from '../../../classes/company';

@Component({
    selector: 'aira-card-list',
    templateUrl: './aira-card-list.component.html',
    styleUrl: './aira-card-list.component.css',
    standalone: false
})
export class AiraCardListComponent {
  @Input() data: any;
  @Input() schema: Record<string, any>;
  @Input() headerKeyName = '';
  @Input() contentKeyName: any;
  @Input() previewOnly: boolean = false;

  contentKeys = [];
  formatterKeys = [];
  cardsToRender: any[] = [];
  leftoverCount: number = 0;
  renderData: any[] = [];
  renderHeaderKeyName = '';

  ngOnInit() {
    this.rebuildCards();
  }

  ngOnChanges() {
    this.rebuildCards();
  }

  rebuildCards(): void {
    this.renderData = this.previewOnly
      ? magicPreviewDummyData.dataForCardList
      : (this.data || []);
    this.renderHeaderKeyName = this.previewOnly ? 'name' : this.headerKeyName;
    const renderContentKeyName = this.previewOnly
      ? 'service_provided'
      : this.contentKeyName;
    this.contentKeys = [];
    this.formatterKeys = [];
    this.cardsToRender = [];
    this.leftoverCount = 0;
    this.handleContentKey(renderContentKeyName);
    this.handleContentFormatter();
    this.handleCardsData();
  }

  handleContentFormatter(): void {
    if (!this.schema.content_formatter) return;
    if (typeof this.schema.content_formatter === 'string') {
      this.formatterKeys = [this.schema.content_formatter];
    } else {
      this.formatterKeys = this.schema.content_formatter;
    }
  }

  handleContentKey(contentKeyName = this.contentKeyName): void {
    if (!contentKeyName) return;
    if (typeof contentKeyName === 'string') {
      this.contentKeys = [contentKeyName];
    } else {
      this.contentKeys = contentKeyName;
    }
  }

  handleCardsData() {
    if (!this.renderData.length) return;

    if (this.renderData.length <= 4) {
      this.cardsToRender = this.renderData;
      return;
    }

    if (this.renderData.length > 4) {
      this.leftoverCount = this.renderData.length - 4;
      this.cardsToRender = this.renderData.slice(0, 4);
    }
  }

  showAllCards() {
    this.cardsToRender = this.renderData;
    this.leftoverCount = null;
  }

  isContentArray(content: any): boolean {
    return Array.isArray(content);
  }
}
